import Model from '@/models/Model.js';

export default class LtiTool extends Model {
    static entity = 'lti_tools';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),

            ...super.fields(),
        };
    }
}
